export const beneficiarySellModalInitValue = {
  data: {
    beneficiary: undefined,
    beneficiaryAllPlans: [],
    societyValue: 0,
    simulatedSocietyValue: 0,
    simulatedRetentionPercent: 0,
    simulatedTotal: 0,
    retentionTotal: 0,
    unitsPrice: 0,
    includeAllUnits: true,
    includeBeneficiaryNotVestedUnits: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeSimulatedSocietyValue(): void {},
    handleChangeSimulatedRetentionPercent(): void {},
    handleChangeIncludeAllUnits(): void {},
    handleChangeIncludeBeneficiaryNotVestedUnits(): void {},
  },
};
